import * as ActionTypes from '../ActionTypes';

const initialState = {
    success_message: "",
    error: false,
    employment_type_options: []
};

const EmploymentTypeReducer = function (state = initialState, action) {
    switch (action.type) {
        case ActionTypes.EMPLOYMENT_TYPE_GET_REQUEST:
            return {
                ...state,
                employment_type_options: []
            };
        case ActionTypes.EMPLOYMENT_TYPE_GET_SUCCESS:
            return {
                ...state,
                success_message: action.payload.message,
                error: action.payload.has_error,
                employment_type_options: action.payload?.data?.data
            };
        case ActionTypes.EMPLOYMENT_TYPE_ADD_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: false,
                success: false,
            };
        case ActionTypes.EMPLOYMENT_TYPE_ADD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                employment_type_options: action.payload?.data?.data
            };
        case ActionTypes.EMPLOYMENT_TYPE_ADD_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        case ActionTypes.EMPLOYMENT_TYPE_UPDATE_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: false,
                success: false,
            };
        case ActionTypes.EMPLOYMENT_TYPE_UPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                employment_type_options: action.payload?.data?.data
            };
        case ActionTypes.EMPLOYMENT_TYPE_UPDATE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        case ActionTypes.EMPLOYMENT_TYPE_DELETE_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: false,
                success: false,
            };
        case ActionTypes.EMPLOYMENT_TYPE_DELETE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                employment_type_options: action.payload?.data?.data
            };
        case ActionTypes.EMPLOYMENT_TYPE_DELETE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        default:
            return state;
    }
}

export default EmploymentTypeReducer;